import { render, staticRenderFns } from "./AdList.vue?vue&type=template&id=c5f25c88&scoped=true&"
import script from "./AdList.vue?vue&type=script&lang=js&"
export * from "./AdList.vue?vue&type=script&lang=js&"
import style0 from "./AdList.vue?vue&type=style&index=0&id=c5f25c88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f25c88",
  null
  
)

export default component.exports